"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.luCountry = void 0;
var _companyNumber = require("../../companyNumber");
// i18next-extract-mark-ns-start Countries

var luCountry = exports.luCountry = function luCountry(t) {
  return {
    id: 'LU',
    name: t('Luxembourg'),
    flag: '🇱🇺',
    zipcodeChecker: function zipcodeChecker(zipcode) {
      return (zipcode === null || zipcode === void 0 ? void 0 : zipcode.length) === 4;
    },
    zipcodeMatcher: function zipcodeMatcher(zipCode, subZoneZipcode) {
      return zipCode.startsWith(subZoneZipcode);
    },
    zipcodePlaceholder: 'e.g. 1445 or 1208',
    phonePrefix: '352',
    phoneLength: 8,
    pricingVersion: 14,
    timezone: 'Europe/Luxembourg',
    currency: 'EUR',
    companyNumber: {
      label: _companyNumber.labels.LU,
      checker: _companyNumber.checkers.LU
    }
  };
};